import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import type { TransientFailureReason } from "../../helpers/classifyApiFailure.js";
import { Banner, BannerList } from "~/components/design-system/index.js";

const messageKeys: Record<TransientFailureReason, string> = {
  connectivity: "pages.caseload.unavailable.connectivity",
  server: "pages.caseload.unavailable.server",
  session: "pages.caseload.unavailable.session",
};

/**
 * Replaces the caseload table when the fetch behind it failed in a way a retry
 * could fix. In place rather than a whole-page error, so a transient failure
 * does not tear down the working screen.
 */
export default function CaseloadUnavailable({
  reason,
  onRetry,
}: {
  reason: TransientFailureReason;
  onRetry: () => void;
}) {
  const { t } = useTranslation();

  return (
    <Box sx={{ mt: 2 }} data-testid="caseload-unavailable">
      <Banner
        bannerType={BannerList.ERROR}
        title={t(messageKeys[reason])}
        rightButtonLabel={t("buttonLabels.tryAgain")}
        rightButtonTestId="caseload-retry"
        onRightButton={onRetry}
      />
    </Box>
  );
}
